import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Stars } from './ReviewCard';

const ARROW_CLS = 'absolute top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow-lg border border-gray-100 flex items-center justify-center text-[#143160] hover:bg-gold-400 hover:text-white transition-colors';

export const reviewKey = (review, i) => review.googleMapsUri || `${review.author}-${i}`;

export const ReviewsHeading = ({ rating, totalRatings }) => (
  <div className="text-center max-w-2xl mx-auto mb-10 space-y-4">
    <div className="inline-flex items-center space-x-3 px-5 py-2.5 bg-white rounded-full shadow-sm border border-gray-100">
      <img src="https://www.gstatic.com/images/branding/product/1x/googleg_32dp.png" alt="Google" className="w-5 h-5" />
      <span className="text-sm font-bold text-gray-700">Google Reviews</span>
    </div>
    <h2 className="text-4xl sm:text-5xl font-serif font-bold text-[#143160]">What Clients Are Saying</h2>
    {typeof rating === 'number' && (
      <div className="flex items-center justify-center space-x-3" data-testid="google-reviews-summary">
        <span className="text-3xl font-bold text-[#143160]">{rating.toFixed(1)}</span>
        <Stars rating={rating} size="w-5 h-5" />
        {totalRatings ? <span className="text-gray-500 text-sm">({totalRatings.toLocaleString()} reviews)</span> : null}
      </div>
    )}
  </div>
);

export const CarouselControls = ({ reviews, idx, go }) => (
  <>
    <button type="button" data-testid="reviews-prev" onClick={() => go(idx - 1)} aria-label="Previous review" className={`${ARROW_CLS} left-0 sm:-left-4`}>
      <ChevronLeft className="w-5 h-5" />
    </button>
    <button type="button" data-testid="reviews-next" onClick={() => go(idx + 1)} aria-label="Next review" className={`${ARROW_CLS} right-0 sm:-right-4`}>
      <ChevronRight className="w-5 h-5" />
    </button>
    <div className="flex justify-center space-x-2 mt-6">
      {reviews.map((r, i) => (
        <button
          key={reviewKey(r, i)}
          type="button"
          data-testid={`reviews-dot-${i}`}
          onClick={() => go(i)}
          aria-label={`Go to review ${i + 1}`}
          className={`h-2.5 rounded-full transition-all ${i === idx ? 'w-7 bg-gold-500' : 'w-2.5 bg-gray-300 hover:bg-gray-400'}`}
        />
      ))}
    </div>
  </>
);
